module.exports = __webpack_public_path__ + "static/media/40.eeb23262.jpeg";